export default "__VITE_ASSET__haZpWGRN__"